import script from "./BlogFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogFeed.vue?vue&type=script&setup=true&lang=js"

import "./BlogFeed.vue?vue&type=style&index=0&id=5fc8f7e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc8f7e2"]])

export default __exports__